import Details from "./Details";
import {useTranslation} from "react-i18next";

export default function Charge({handleClose, money, coins}) {
  const {t} = useTranslation()

  return (
    <div className="scroll-body">
      <div className="withdraw-container">
        <div className="right-side">
          <p>{t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.AccountDepositApplication.Label')}</p>
          <div className="ri-input">
            <label>{t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.Amount.Place.Holder')}</label>
            <input/>

          </div>
          <div className="ri-btn">
            <button className="btn-st-1">
              {t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.Withdraw.Button')}
            </button>
            <button onClick={handleClose} className="btn-st-2">
              {t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.Cancel.Button')}
            </button>
          </div>
        </div>
        <div className="left-side">
          <Details money={money} coins={coins}/>
        </div>
      </div>
    </div>
  )
}
